import { render } from "./ContactInfoForm.vue?vue&type=template&id=181a5da6&scoped=true"
import script from "./ContactInfoForm.vue?vue&type=script&lang=js"
export * from "./ContactInfoForm.vue?vue&type=script&lang=js"

import "./ContactInfoForm.vue?vue&type=style&index=0&id=181a5da6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-181a5da6"]])

export default __exports__